export default {
    computed: {
        i18n_campaign_name(){
            return (campaign) => {
                if (!campaign || !campaign.campaign_name) {
                    return '';
                }
                if(this.$i18n.locale === 'ko') {
                    return campaign.campaign_name;
                }    
                else if(this.$i18n.locale === 'en') {
                    return campaign.campaign_name_ea || campaign.campaign_name;
                } 
                else if(this.$i18n.locale === 'ca') {
                    return campaign.campaign_name_ca || campaign.campaign_name_ea || campaign.campaign_name;
                }
                return campaign.campaign_name;
            };
        }
    }
};
